export default __webpack_public_path__ + "static/media/ico_cuando.55267523.svg";